export const actionAddToNextList = (data) => ({
    type: 'ACTION_ADD_TO_NEXT_LIST', data
});

export const actionRemoveFromNextList = (data) => ({
    type: 'ACTION_REMOVE_FROM_NEXT_LIST', data
});

export const actionRemoveAllItemFromNextList = () => ({
    type: 'ACTION_REMOVE_ALL_ITEM_IN_NEXT_LIST'
});
